module.exports = __webpack_public_path__ + "assets/img/points_0.23c38808.svg";